// import ChangesMonitor from 'src/constrains/SalesChannelContent-Revamp/HomePageChangesMonitor';
import ContentGrid from '@/src/components/SalesChannelComponents/SalesChannelContentGrid';
import { get } from 'lodash';
import Wrapper from 'src/constrains/SalesChannelContentWrapperRevamp';
import React from 'react';
import { Form } from '@/src/components/RcForm';
import Visible from '@/src/components/Modules-revamp/Visible';
import { EPreviewSize } from '@/src/types/common/SalesChannel';
import LoadingAnimation from './LoadingAnimation';
import FlashSaleBarStyle from './FlashSaleBarStyle';
import FloatingActionButtonStyle from './FloatingActionButtonStyle';
import PrimaryCallToActionButtonStyle from './PrimaryCallToActionButtonStyle';
import ProductDetailPageTabBarStyle from './ProductDetailPageTabBarStyle';
import RemainingStockTextStyle from './RemainingStockTextStyle';
import SecondaryCallToActionButtonStyle from './SecondaryCallToActionButtonStyle';
import TopLeaderBoardBanner from './TopLeaderBoardBanner';
import { useAppearance } from './hooks/useAppearance';

import ChangesMonitor from 'src/pages/SalesChannelContentEditor/Components/ChangeMonitor';
import { getI18nFromGeneral } from 'src/tools/tools';
import RouteBlock from 'src/constrains/RouterBlock/RouterBlock';
const Appearance = () => {
  const {
    salesChannel,
    hasModified,
    onGoBack,
    pcForm,
    mobileForm,
    tabletForm,
    loaded,
    setHasModified,
    handleOnDiscard,
    handleOnReset,
    handleOnCopy,
    handleFieldsChange,
    handleOnSubmit,
    data,
  } = useAppearance();
  const headerProps = {
    title: get(salesChannel, 'name'),
    description: get(data, 'salesChannelContent.versionName'),
    status: get(data, 'salesChannelContent.status'),
    hasModified,
    onSubmit: handleOnSubmit,
    onDiscard: handleOnDiscard,
    onGoBack,
  };

  const commonProps = {
    handleOnSectionReset: handleOnReset,
    handleOnSectionCopy: handleOnCopy,
  };
  return (
    <Wrapper headerProps={headerProps}>
      <ChangesMonitor
        loaded={loaded}
        setHasModified={setHasModified}
        pcForm={pcForm}
        tabletForm={tabletForm}
        mobileForm={mobileForm}
      />
      <RouteBlock
        onConfirm={(f) => f()}
        okText={getI18nFromGeneral('general.commonHeader.discard_text')}
        active={hasModified}
        title={getI18nFromGeneral('general.commonHeader.discard_header')}
        content={getI18nFromGeneral('general.commonHeader.discard_content')}
      />
      <ContentGrid
        configCols={[
          {
            child: (
              <Form form={pcForm} onFieldsChange={handleFieldsChange}>
                <Visible alwaysVisible breakpoint={EPreviewSize.WIDE} />
                <LoadingAnimation breakpoint={EPreviewSize.WIDE} />
                <TopLeaderBoardBanner breakpoint={EPreviewSize.WIDE} />
                <ProductDetailPageTabBarStyle breakpoint={EPreviewSize.WIDE} />
                <FlashSaleBarStyle breakpoint={EPreviewSize.WIDE} />
                <PrimaryCallToActionButtonStyle
                  breakpoint={EPreviewSize.WIDE}
                />
                <SecondaryCallToActionButtonStyle
                  breakpoint={EPreviewSize.WIDE}
                />
                <FloatingActionButtonStyle breakpoint={EPreviewSize.WIDE} />
                <RemainingStockTextStyle breakpoint={EPreviewSize.WIDE} />
              </Form>
            ),
          },
          {
            child: (
              <Form form={tabletForm}>
                <Visible alwaysVisible breakpoint={EPreviewSize.TABLET} />
                <LoadingAnimation
                  breakpoint={EPreviewSize.TABLET}
                  {...commonProps}
                />
                <TopLeaderBoardBanner
                  breakpoint={EPreviewSize.TABLET}
                  {...commonProps}
                />
                <ProductDetailPageTabBarStyle
                  disabled
                  breakpoint={EPreviewSize.TABLET}
                />
                <FlashSaleBarStyle disabled breakpoint={EPreviewSize.TABLET} />
                <PrimaryCallToActionButtonStyle
                  disabled
                  breakpoint={EPreviewSize.TABLET}
                />
                <SecondaryCallToActionButtonStyle
                  disabled
                  breakpoint={EPreviewSize.TABLET}
                />
                <FloatingActionButtonStyle
                  disabled
                  breakpoint={EPreviewSize.TABLET}
                />
                <RemainingStockTextStyle
                  disabled
                  breakpoint={EPreviewSize.TABLET}
                />
              </Form>
            ),
          },
          {
            child: (
              <Form form={mobileForm}>
                <Visible alwaysVisible breakpoint={EPreviewSize.MOBILE} />
                <LoadingAnimation
                  breakpoint={EPreviewSize.MOBILE}
                  {...commonProps}
                />
                <TopLeaderBoardBanner
                  breakpoint={EPreviewSize.MOBILE}
                  {...commonProps}
                />
                <ProductDetailPageTabBarStyle
                  disabled
                  breakpoint={EPreviewSize.MOBILE}
                />
                <FlashSaleBarStyle disabled breakpoint={EPreviewSize.MOBILE} />
                <PrimaryCallToActionButtonStyle
                  disabled
                  breakpoint={EPreviewSize.MOBILE}
                />
                <SecondaryCallToActionButtonStyle
                  disabled
                  breakpoint={EPreviewSize.MOBILE}
                />
                <FloatingActionButtonStyle
                  disabled
                  breakpoint={EPreviewSize.MOBILE}
                />
                <RemainingStockTextStyle
                  disabled
                  breakpoint={EPreviewSize.MOBILE}
                />
              </Form>
            ),
          },
        ]}
        mainCol={null}
      />
    </Wrapper>
  );
};
export default Appearance;
